import { render, staticRenderFns } from "./category-breadcrumb-favorite.vue?vue&type=template&id=a0aadd42&"
import script from "./category-breadcrumb-favorite.vue.ts?vue&type=script&lang=ts&"
export * from "./category-breadcrumb-favorite.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports